import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { LogOut, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { pageVariants } from './utils';
import { CheckOutForm } from './CheckOutForm';
import { BitsyCheckoutView } from './BitsyCheckoutView';
import { useGuestPortal } from './GuestPortalContext';

export function CheckOutWrapper({ setView, setSuccessMessage, bitsyCrewEnabled }) {
  const { t, language } = useGuestPortal();
  const [mode, setMode] = useState(null);
  
  if (!bitsyCrewEnabled && mode === null) {
    return <CheckOutForm setView={setView} setSuccessMessage={setSuccessMessage} />;
  }
  
  if (mode === 'form') {
    return <CheckOutForm setView={setView} setSuccessMessage={setSuccessMessage} />;
  }
  
  if (mode === 'bitsy') {
    return <BitsyCheckoutView setView={setView} setSuccessMessage={setSuccessMessage} onSwitchToForm={() => setMode('form')} />;
  }
  
  return (
    <motion.div
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
      className="w-full max-w-md"
    >
      <Card className="bg-vault-surface border border-vault-border shadow-xl p-6 rounded-2xl">
        <CardHeader className="text-center pb-6">
          <CardTitle className="font-outfit text-2xl font-bold text-vault-text">
            {language === 'es' ? '¿Cómo desea registrar su salida?' : 'How would you like to check out?'}
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <Button
            onClick={() => setMode('bitsy')}
            className="w-full h-20 text-lg flex flex-col items-center justify-center gap-2 bg-gradient-to-r from-orange-500 to-red-500 hover:from-orange-600 hover:to-red-600 text-white font-bold"
            data-testid="bitsy-checkout-btn"
          >
            <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
            </svg>
            <span>{language === 'es' ? 'Hablar con Bitsy' : 'Talk to Bitsy'}</span>
          </Button>
          
          <Button
            onClick={() => setMode('form')}
            className="w-full h-16 text-lg flex items-center justify-center gap-3 bg-amber-600 hover:bg-amber-700 text-white font-bold"
            data-testid="quick-checkout-btn"
          >
            <LogOut className="w-5 h-5" />
            <span>{language === 'es' ? 'Salida Rápida' : 'Quick Check-Out'}</span>
          </Button>
          
          <Button
            onClick={() => setView("menu")}
            variant="outline"
            className="w-full h-12 flex items-center justify-center gap-2 mt-4"
            data-testid="checkout-back-to-menu-btn"
          >
            <ArrowLeft className="w-4 h-4" />
            {t.backToMenu || "Back to Menu"}
          </Button>
        </CardContent>
      </Card>
    </motion.div>
  );
}
